var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',{staticClass:"container"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-20 h-80 flex justify-center items-center w-full h-full wrapper"},[_c('img',{staticClass:"w-20 animate-bounce",attrs:{"src":require("../../assets/images/ayadi-loader.svg"),"alt":"Ayadi loader"}})])
}]

export { render, staticRenderFns }